import { render, staticRenderFns } from "./fixed-banner.vue?vue&type=template&id=491c64fa"
import script from "./fixed-banner.vue?vue&type=script&lang=js"
export * from "./fixed-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports